import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="read-more"
export default class ReadMoreController extends Controller {
  static targets = ["content", "moreButton", "lessButton"];

  static classes = ["truncate", "hide"];

  static values = {
    lines: Number
  };

  connect() {
    this.isExpanded = false;
    this.render();
  }

  render() {
    if (this.isExpanded) return;

    this.showAllContent();

    requestAnimationFrame(() => {
      const shouldTruncate =
        this.contentTarget.scrollHeight > this.expectedHeight() + 5;

      if (shouldTruncate) {
        this.showLess();
      } else {
        this.hide(this.moreButtonTarget);
        this.hide(this.lessButtonTarget);
      }
    });
  }

  showMore() {
    this.isExpanded = true;
    this.showAllContent();
    this.hide(this.moreButtonTarget);
    this.show(this.lessButtonTarget);
  }

  showLess() {
    this.isExpanded = false;
    this.truncateContent();
    this.show(this.moreButtonTarget);
    this.hide(this.lessButtonTarget);
  }

  showAllContent() {
    this.contentTarget.classList.remove(this.truncateClass);
  }

  truncateContent() {
    this.contentTarget.style.webkitLineClamp = this.linesValue;
    this.contentTarget.classList.add(this.truncateClass);
  }

  expectedHeight() {
    const lineHeight = Number.parseFloat(getComputedStyle(this.contentTarget).lineHeight);
    return lineHeight * this.linesValue;
  }

  show(target) {
    target.classList.remove(this.hideClass);
  }

  hide(target) {
    target.classList.add(this.hideClass);
  }
}
